/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { getImagePath } from "../utilities";

export default ({ uri, width, height }) => {
  return (
    <img
      alt={""}
      className={"ProductImage"}
      width={width || "auto"}
      height={height || "auto"}
      src={getImagePath(uri)}
    />
  );
};
